import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Header, TopBar } from '../components/Header';
import { Footer } from '../components/Footer';


const termsData = [
  { 
    id: 'acceptation', 
    title: '1. Acceptation et accès à la plateforme ORTEGA', 
    content: `La plateforme ORTEGA est une solution numérique dédiée à la vente, à l’installation et à la maintenance 
    d’équipements biomédicaux, informatiques, de mobilier de bureau, ainsi qu’à la fourniture de logiciels personnalisés.

    En accédant ou en utilisant la plateforme ORTEGA, vous acceptez pleinement et sans réserve les présentes conditions 
    d’utilisation. Ces conditions s’appliquent à l’ensemble des utilisateurs, qu’ils soient des particuliers ou des entreprises.

    L’accès à la plateforme peut être temporairement suspendu ou limité pour des raisons de maintenance, de mise à jour, 
    de sécurité ou de force majeure. ORTEGA se réserve le droit de restreindre ou de suspendre l’accès à tout utilisateur 
    en cas de non-respect des présentes conditions ou d’utilisation abusive des services.`
  },

  { 
    id: 'compte', 
    title: '2. Compte utilisateur', 
    content: `Certaines fonctionnalités de la plateforme ORTEGA nécessitent la création d’un compte utilisateur. 
    Lors de l’inscription, l’utilisateur s’engage à fournir des informations exactes, complètes et à jour.

    L’utilisateur est seul responsable de la confidentialité de ses identifiants de connexion et de toutes les actions 
    effectuées via son compte, notamment les commandes de produits, les demandes d’installation ou de maintenance, 
    ainsi que les sollicitations de logiciels personnalisés.

    Le partage, le prêt ou la cession d’un compte à un tiers est strictement interdit. ORTEGA décline toute responsabilité 
    en cas d’utilisation frauduleuse du compte résultant d’une négligence de l’utilisateur.`
  },

  { 
    id: 'utilisation', 
    title: "3. Utilisation de la plateforme et des services",
    content: `L’utilisateur s’engage à utiliser la plateforme ORTEGA de manière légale, responsable et conforme 
    aux lois et réglementations en vigueur.

    La plateforme permet notamment :
    - la commande d’équipements biomédicaux, informatiques et de mobilier de bureau ;
    - la soumission de demandes d’installation ou de maintenance ;
    - la demande, l’achat ou l’utilisation de logiciels personnalisés.

    Toute information, demande ou contenu transmis par l’utilisateur via la plateforme relève de sa seule responsabilité. 
    Il est strictement interdit d’utiliser la plateforme à des fins frauduleuses, illégales, diffamatoires ou nuisibles 
    à l’image de ORTEGA ou de ses partenaires. ORTEGA se réserve le droit de refuser ou d’annuler toute demande non conforme.`
  },

  { 
    id: 'propriete', 
    title: "4. Propriété intellectuelle et données personnelles",
    content: `L’ensemble des éléments constituant la plateforme ORTEGA, incluant notamment les textes, logos, images, 
    graphiques, interfaces, logiciels, codes sources et bases de données, est protégé par les lois relatives à la 
    propriété intellectuelle. Toute reproduction, modification ou exploitation sans autorisation écrite préalable 
    est strictement interdite.

    Les données personnelles collectées via la plateforme sont traitées dans le respect de la réglementation en vigueur 
    en matière de protection des données (RGPD ou législation locale équivalente). Ces données sont utilisées 
    exclusivement pour la gestion des comptes, le traitement des commandes, les services d’installation et de maintenance, 
    ainsi que l’amélioration continue des services ORTEGA.

    ORTEGA s’engage à ne jamais vendre ou céder les données personnelles des utilisateurs à des tiers sans leur consentement explicite.`
  },

  { 
    id: 'paiements', 
    title: "5. Commandes, paiements et responsabilités",
    content: `Les prix des produits, services d’installation, de maintenance et logiciels personnalisés sont clairement 
    indiqués avant toute validation de commande.

    Les paiements doivent être effectués exclusivement via les moyens de paiement proposés sur la plateforme ORTEGA. 
    Toute commande validée engage l’utilisateur à respecter ses obligations financières.

    ORTEGA met tout en œuvre pour assurer la qualité des produits et services proposés, mais ne saurait être tenue 
    responsable des dommages indirects, pertes d’exploitation ou litiges résultant d’une mauvaise utilisation 
    des équipements, logiciels ou services fournis. L’utilisateur demeure entièrement responsable de l’usage 
    des produits et solutions acquis via la plateforme.`
  },

  { 
    id: 'suspension', 
    title: "6. Suspension, modification et juridiction",
    content: `En cas de non-respect des présentes conditions d’utilisation, ORTEGA se réserve le droit de suspendre 
    ou de supprimer le compte de l’utilisateur, sans préavis ni indemnité.

    Les conditions d’utilisation et la politique de confidentialité peuvent être modifiées à tout moment afin de 
    s’adapter à l’évolution des services, des technologies ou de la législation en vigueur. Les utilisateurs seront 
    informés de toute modification significative.

    Les présentes conditions sont régies par la loi du pays d’exploitation de la plateforme ORTEGA. 
    Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence exclusive des tribunaux compétents.`
  },
];


export default function TermsOfUse() {
  const [activeSectionId, setActiveSectionId] = useState('');
  const sectionRefs = useRef({});

  useEffect(() => {
    const handleScroll = () => {
      let currentActiveId = '';
      const offset = 150;

      for (let i = termsData.length - 1; i >= 0; i--) {
        const ref = sectionRefs.current[termsData[i].id];
        if (ref) {
          const rect = ref.getBoundingClientRect();
          if (rect.top <= offset && rect.bottom >= offset) {
            currentActiveId = termsData[i].id;
            break;
          }
        }
      }
      setActiveSectionId(currentActiveId);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleNavLinkClick = (id) => {
    const section = sectionRefs.current[id];
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="container-fluid bg-light">
      {/* _____________________SECTION HEADER EQUIPMENT ___________________ */} 
      
      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header /> </div>

      <Container fluid="lg" className="p-0 pt-3">
        <Row className="mt-4">
          <Col
            md={3}
            className="bg-light flex-column p-4 shadow-sm sticky-top d-none d-md-flex z-index-sm"
            style={{ top: 0, height: '100vh', overflowY: 'auto' }}
          >
            <div className="d-flex flex-column py-5">
              <span className="fs-3">Nos conditions d'utilisation</span>
              <p className="text-muted lead">Veuillez lire attentivement ces conditions d'utilisation.</p>
            </div>
            <Nav className="flex-column" activeKey={activeSectionId}>
              {termsData.map((item) => (
                <Nav.Link
                  key={item.id}
                  eventKey={item.id}
                  onClick={() => handleNavLinkClick(item.id)}
                  className={`py-3 d-flex align-items-center lead ${
                    activeSectionId === item.id ? 'active-link' : 'text-muted'
                  }`}
                >
                  {item.title}
                </Nav.Link>
              ))}
            </Nav>
          </Col>

          <Col md={9} className="py-5 px-4">
            {termsData.map((item) => (
              <div
                key={item.id}
                id={item.id}
                ref={(el) => (sectionRefs.current[item.id] = el)}
                className="mb-4 pb-4"
              >
                <h2 className="fs-4 mb-3 ">{item.title}</h2>
                <p className="text-muted lead">{item.content}</p>
              </div>
            ))}
          </Col>
        </Row>
      </Container>

      <div
        className="d-md-none bg-light p-2 shadow-lg fixed-bottom"
        style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
      >
        <Nav className="justify-content-center" activeKey={activeSectionId}>
          {termsData.map((item) => (
            <Nav.Link
              key={item.id}
              eventKey={item.id}
              onClick={() => handleNavLinkClick(item.id)}
              className="py-1 px-3 d-inline-block text-center"
              style={{
                color: '#307072',
                borderBottom: activeSectionId === item.id ? '2px solid #307072' : 'none',
                backgroundColor: activeSectionId === item.id ? 'rgba(236,241,241,255)' : '#fff',
              }}
            >
              <div className="d-block mb-1 mx-auto">{item.icon}</div>
              <small>{item.title.split('.')[0]}.</small>
            </Nav.Link>
          ))}
        </Nav>
      </div>

      {/* _____________________SECTION FOOTER EQUIPMENT ___________________ */} 
          
      <div className='row'>
        <Footer />
      </div>

    </div>
  );
}
